import { withInstall } from '@lit-element/utils'
import ResizeObserver from './src/resizeObserver.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtResizeObserver: SFCWithInstall<typeof ResizeObserver> =
  withInstall(ResizeObserver)
export default LtResizeObserver

export * from './src/resizeObserver'
